import React, { PropTypes } from 'react';
import classNames from 'classnames';

import { CATEGORIES } from '../../utils/category-utils';
import { CATEGORY_DESCRIPTIONS } from './category-descriptions';

import styles from './category-panel.cssm';


const CategoryPanel = ({currentCategory, size}) => {

  const renderSmall = (currentCategory) => {
    let panelText = CATEGORY_DESCRIPTIONS[currentCategory.className];
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.innerText}>{panelText}</div>
            </div>
        </div>
    );
  }

  const renderLarge = (currentCategory) => {
    return (
        <div className={classNames(styles.container, currentCategory ? null : styles.empty)}>
            <div className={styles.inner}>
                <div>
                    <h1 className={styles[`${currentCategory.className}Text`]}>
                        {currentCategory.label}
                    </h1>
                    <div className={styles.innerText}>
                        {CATEGORY_DESCRIPTIONS[currentCategory.className]}
                    </div>
                </div>
            </div>
        </div>
    );
  }

  let category = currentCategory || {
    label: 'THE TOP STORIES',
    className: 'all'
  };

  if (size === 'large') {
    return renderLarge(category);
  } else {
    return renderSmall(category);
  }
}

CategoryPanel.propTypes = {
  currentCategory: PropTypes.oneOf(CATEGORIES),
  size: PropTypes.string
}

export default CategoryPanel;



// WEBPACK FOOTER //
// ./src/components/category-panel/category-panel.js